<app-frame [overlay]="false" [title]="title" (neadClose)="closeVisitForm()" autocomplete="off">
	<div>
		There are past due follow-ups assigned to another Staff member. Would you like to address them?
	</div>
	<app-form-actions-content>
		<form-button (clickOnButton)="goToFollowUp()">Address</form-button>
		<form-button (clickOnButton)="continueSave()" buttonType="warning">Ignore</form-button>
	</app-form-actions-content>
</app-frame>
